import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  iconBig: {
    padding: '0px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '35px',
    backgroundRepeat: 'no-repeat',
    fontSize: 30,
    width: '100%'
  },
  bigButton: {
    display: 'block',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '10px 0 4px 0',
    color: '#2196f3'
  },
  number: {
    width: '15px',
    height: '15px',
    paddingLeft: '1px',
    backgroundColor: 'red',
    color: 'white',
    borderRadius: '30px',
    fontSize: 11,
    position: 'absolute',
    top: '7px',
    lineHeight: '1.5',
    right: '10px',
    fontWeight: 500
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    height: '40px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textFs9: {
    fontSize: 9,
    fontWeight: 600,
    height: '40px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  iconMid: {
    padding: '0px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '35px',
    backgroundRepeat: 'no-repeat',
    fontSize: 14,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, classStyle, numberCount, label, onClickAction, isFukuoka }) => {
    let noticeNumber;
    console.log(numberCount);
    if (numberCount && numberCount !== '') {
      noticeNumber = <div className={classes.number}>{numberCount}</div>;
    } else {
      noticeNumber = '';
    }
    return (
      <Button
        className={classes.bigButton}
        onClick={() => {
          onClickAction();
        }}
      >
        {noticeNumber}
        <i
          className={`${classStyle} ${
            isFukuoka ? classes.iconMid : classes.iconBig
          }`}
        />
        <div className={isFukuoka ? classes.textFs9 : classes.text}>
          {label}
        </div>
      </Button>
    );
  }
);

export default withStyles(styles)(button);
